<h2 mat-dialog-title>Valider le document</h2>
<div mat-dialog-content>
  <div>
    <p>
      Préciser la catégorie et le type du document <i>{{ data.doc.name }}</i>
    </p>
  </div>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="docForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Catégorie</mat-label>
          <mat-select required formControlName="category">
            <mat-option *ngFor="let categ of propHelper.getDocumentCategories()" [value]="categ">
              {{ propHelper.getDocumentCategoryName(categ,data.prop.type) }}</mat-option>
          </mat-select>
          <mat-error *ngIf="f('category').hasError('required')">Champs requis</mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Type</mat-label>
          <mat-select required formControlName="type">
            <mat-option *ngFor="let type of propHelper.getDocumentsTypes()" [value]="type">
              {{ propHelper.getDocumentTypeName(type) }}</mat-option>
          </mat-select>
          <mat-error *ngIf="f('type').hasError('required')">Champs requis</mat-error>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button mat-flat-button class="m-2" color="primary" appTooltip="Valider" type="submit"
          [disabled]="formSubmitting">
          Valider
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close appTooltip="Annuler" (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
